import { isFunction } from "lodash";

const renderIf = (predicate) => (elemOrThunk) =>
    predicate ? (isFunction(elemOrThunk) ? elemOrThunk() : elemOrThunk) : null;
export default renderIf;
